export default {
  id: null,
  companyID: null,
  type: null,
  condition: null,
  cnpj: null,
  name: null,
  fantasyName: null,
  email: null,
  contact: null,
  phoneNumber: null,
  cellNumber: null,
  cityID: null,
  stateID: null,
  address: null,
  addressNumber: null,
  complement: null,
  district: null,
  zipcode: null,
  workImage: false,
  sendPhoto: false,
  acceptParts: false,
  description: null,
  status: true,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/mechanicalworkshop/model/sinistermechanicalworkshopmodel.js